(function navaccountScript($, Drupal) {
    Drupal.behaviors.navaccount = {
        attach: function (context, settings) {

            $('.go-back').on('click', function(event){
                event.preventDefault();
                $('.oo-navi-pane').removeClass('moves-out');
            });

            //open sub-navigation
            var $first_lvl_nav_links = $('.oo-navi-1st-pane > a');
            console.log($first_lvl_nav_links.length);
            $first_lvl_nav_links.on('click', function(event){
                event.preventDefault();
                $('.oo-navi-pane').toggleClass('moves-out');
            });

        },
    };
}(jQuery, Drupal));

// jQuery(document).ready(function($){

    //move nav element position according to window width
    // moveNavigation();
    // $(window).on('resize', function(){
    //     (!window.requestAnimationFrame) ? setTimeout(moveNavigation, 300) : window.requestAnimationFrame(moveNavigation);
    // });

    //mobile version - open/close navigation
    // $('.cd-nav-trigger').on('click', function(event){
    //     event.preventDefault();
    //     if($('header').hasClass('nav-is-visible')) $('.moves-out').removeClass('moves-out');
    //
    //     $('header').toggleClass('nav-is-visible');
    //     $('.cd-main-nav').toggleClass('nav-is-visible');
    //     $('.cd-main-content').toggleClass('nav-is-visible');
    // });

    //mobile version - go back to main navigation
    // $('.go-back').on('click', function(event){
    //     event.preventDefault();
    //     $('.oo-navi-pane').removeClass('moves-out');
    // });

    //open sub-navigation
    // $('.oo-navi-1st-pane > a').on('click', function(event){
    //     event.preventDefault();
    //     $('.oo-navi-pane').toggleClass('moves-out');
    // });

    // function moveNavigation(){
    //     var navigation = $('.shop-nav-oc');
    //     var screenSize = checkWindowWidth();
    //     if ( screenSize ) {
    //         //desktop screen - insert navigation inside header element
    //         navigation.detach();
    //         navigation.insertBefore('.cd-nav-trigger');
    //     } else {
    //         //mobile screen - insert navigation after .cd-main-content element
    //         navigation.detach();
    //         navigation.insertAfter('.cd-main-content');
    //     }
    // }

    // function checkWindowWidth() {
    //     var mq = window.getComputedStyle(document.querySelector('header'), '::before').getPropertyValue('content').replace(/"/g, '').replace(/'/g, "");
    //     return ( mq == 'mobile' ) ? false : true;
    // }
// });

// (function shopnavocScript($, Drupal) {
//   Drupal.behaviors.shopnavoc = {
//     attach: function (context, settings) {
//
//     },
//   };
// }(jQuery, Drupal));
